// extracted by mini-css-extract-plugin
module.exports = {"accordion":"Accordion_accordion__18Dxq","headline":"Accordion_headline__2Wld-","closed":"Accordion_closed__2PKS8","chevron":"Accordion_chevron__2NyiS"};